import React from 'react';

interface ITitleProps {
  children: React.ReactNode;
}

export const Title: React.FC<ITitleProps> = ({ children }) => (
  <h3
    className={`
    tw-lf-title-sm tw-mt-4
    before:tw-mb-3 before:tw-block before:tw-h-[2px]
    before:tw-w-[25px] before:tw-bg-yellow-600
    before:tw-content-['']
  `}
  >
    {children}
  </h3>
);
